import {
    // connections
    FETCH_CONNECTIONS_START,
    FETCH_CONNECTIONS_SUCCESS,
    FETCH_CONNECTIONS_FAIL,
    RESET_CONNECTIONS,
    // pending connections
    FETCH_PENDING_CONNECTIONS_START,
    FETCH_PENDING_CONNECTIONS_SUCCESS,
    FETCH_PENDING_CONNECTIONS_FAIL,
    UPDATE_PENDING_CONNECTION_DISMISSING_STATUS,
    REMOVE_PENDING_CONNECTION
} from 'actions/ActionTypes';

export const DISMISSING_STATE = {
    ACCEPT: 'ACCEPT',
    DELETE: 'DELETE',
    NONE: 'NONE'
};

const INITIAL_STATE = {
    connections: [],
    connectionFullName: '',
    connectionsFetching: false,
    connectionsFetchSuccess: false,
    connectionsFetchFail: false,
    hasMoreToLoad: false,
    pendingConnections: [],
    pendingConnectionsFetching: false,
    pendingConnectionsFetchSuccess: false,
    pendingConnectionsFetchFail: false
};

const connectionsFetching = (state) => ({
    ...state,
    connectionsFetching: true,
    connectionsFetchSuccess: false,
    connectionsFetchFail: false
});

const connectionsFetchFinished = (isSuccess) => (state, { data, connectionFullName, hasMoreToLoad, replace }) => {
    let connections;
    if (isSuccess) {
        connections = replace ? data : state.connections.concat(data);
    } else {
        connections = state.connections;
    }
    return {
        ...state,
        connections,
        connectionFullName: isSuccess ? connectionFullName : '',
        connectionsFetching: false,
        connectionsFetchSuccess: isSuccess,
        connectionsFetchFail: !isSuccess,
        hasMoreToLoad: isSuccess ? hasMoreToLoad : state.hasMoreToLoad
    };
};

const pendingConnectionsFetching = (state) => ({
    ...state,
    pendingConnectionsFetching: true,
    pendingConnectionsFetchSuccess: false,
    pendingConnectionsFetchFail: false
});

const pendingConnectionsFetchFinished = (isSuccess) => (state, { data }) => ({
    ...state,
    pendingConnections: isSuccess
        ? data.map((connection) => ({
              ...connection,
              dismissingStatus: DISMISSING_STATE.NONE
          }))
        : state.pendingConnections,
    pendingConnectionsFetching: false,
    pendingConnectionsFetchSuccess: isSuccess,
    pendingConnectionsFetchFail: !isSuccess
});

const updatePendingConnectionDismissingStatus = (state, action) => {
    const { displayName, status } = action.payload;
    return {
        ...state,
        pendingConnections: state.pendingConnections.map((connection) => {
            if (connection.displayName === displayName) {
                return {
                    ...connection,
                    dismissingStatus: status
                };
            }
            return connection;
        })
    };
};

const removePendingConnection = (state, action) => {
    const { displayName } = action.payload;
    return {
        ...state,
        pendingConnections: state.pendingConnections.filter((connection) => connection.displayName !== displayName)
    };
};

const resetConnections = (state) => {
    const {
        connections,
        connectionFullName,
        connectionsFetching,
        connectionsFetchSuccess,
        connectionsFetchFail,
        hasMoreToLoad
    } = INITIAL_STATE;
    return {
        ...state,
        connections,
        connectionFullName,
        connectionsFetching,
        connectionsFetchSuccess,
        connectionsFetchFail,
        hasMoreToLoad
    };
};

export const getConnections = (state) => state.connections.connections;
export const getConnectionFullName = (state) => state.connections.connectionFullName;
export const getConnectionsFetching = (state) => state.connections.connectionsFetching;
export const getConnectionsFetchSuccess = (state) => state.connections.connectionsFetchSuccess;
export const getConnectionsFetchFail = (state) => state.connections.connectionsFetchFail;
export const getHasMoreToLoad = (state) => state.connections.hasMoreToLoad;
export const getPendingConnections = (state) => state.connections.pendingConnections;
export const getPendingConnectionsFetchSuccess = (state) => state.connections.pendingConnectionsFetchSuccess;

const handlers = {
    [FETCH_CONNECTIONS_START]: connectionsFetching,
    [FETCH_CONNECTIONS_SUCCESS]: connectionsFetchFinished(true),
    [FETCH_CONNECTIONS_FAIL]: connectionsFetchFinished(false),
    [FETCH_PENDING_CONNECTIONS_START]: pendingConnectionsFetching,
    [FETCH_PENDING_CONNECTIONS_SUCCESS]: pendingConnectionsFetchFinished(true),
    [FETCH_PENDING_CONNECTIONS_FAIL]: pendingConnectionsFetchFinished(false),
    [RESET_CONNECTIONS]: resetConnections,
    [UPDATE_PENDING_CONNECTION_DISMISSING_STATUS]: updatePendingConnectionDismissingStatus,
    [REMOVE_PENDING_CONNECTION]: removePendingConnection
};

export default function connections(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}
